import React from "react";
import { Layout, LegacyCard as Card, SkeletonDisplayText, SkeletonBodyText, BlockStack } from "@shopify/polaris";

const Skeleton = () => {
  // const layouts = [...Array(3).keys()];
  // return layouts.map((_, index) => {
  //   return (
  //     // eslint-disable-next-line react/no-array-index-key

  //   );
  // });

  return (
    <Layout.Section key={`SkeletonLayoutSection${0}`}>
      <Card sectioned>
        <BlockStack gap="4">
          <SkeletonDisplayText size="small" />
          <SkeletonBodyText />
        </BlockStack>
      </Card>
      <Card sectioned>
        <BlockStack gap="4">
          <SkeletonDisplayText size="small" />
          <SkeletonBodyText />
        </BlockStack>
      </Card>
    </Layout.Section>
  );
};

export default Skeleton;
